"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdatingVisibility = exports.isLoadingUnderlyingTerms = exports.instanceUnderlyingTerms = exports.hasUnderlyingTerms = exports.hasAPIGroupInstances = exports.apiGroupInstances = exports.apiGroupInstance = void 0;
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/utils/assets");
var _reselect = require("reselect");
var fetchedAPIGroup = function fetchedAPIGroup(state, _ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    versionGroup = _ref.versionGroup;
  var key = (0, _assets.getGAPKey)({
    groupId: groupId,
    assetId: assetId,
    versionGroup: versionGroup
  });
  return state.apiGroups.data[key];
};
var apiGroupUnderlyingTerms = (0, _reselect.createSelector)(fetchedAPIGroup, function (group) {
  return group && group.underlyingTerms || [];
});
var apiGroupInstances = exports.apiGroupInstances = (0, _reselect.createSelector)(fetchedAPIGroup, function (state, params) {
  return params;
}, function (group, _ref2) {
  var filterDeprecated = _ref2.filterDeprecated;
  return (group && group.instances || []).filter(function (_ref3) {
    var deprecated = _ref3.deprecated;
    return !(filterDeprecated && deprecated);
  });
});
var hasAPIGroupInstances = exports.hasAPIGroupInstances = (0, _reselect.createSelector)(apiGroupInstances, function (instances) {
  return instances.length > 0;
});
var apiGroupInstance = exports.apiGroupInstance = (0, _reselect.createSelector)(fetchedAPIGroup, hasAPIGroupInstances, function (state, params) {
  return params;
}, function (group, $hasAPIGroupInstances, _ref4) {
  var apiGroupInstanceId = _ref4.apiGroupInstanceId;
  return $hasAPIGroupInstances ? group.instances.find(function (_ref5) {
    var id = _ref5.id;
    return id === apiGroupInstanceId;
  }) : null;
});
var instanceUnderlyingTerms = exports.instanceUnderlyingTerms = (0, _reselect.createSelector)(apiGroupUnderlyingTerms, function (state, params) {
  return params;
}, function ($apiGroupUnderlyingTerms, _ref6) {
  var apiGroupInstanceId = _ref6.apiGroupInstanceId;
  var apiGroupInstanceTerms = $apiGroupUnderlyingTerms.find(function (_ref7) {
    var id = _ref7.id;
    return id.toString() === apiGroupInstanceId.toString();
  });
  if (apiGroupInstanceTerms && apiGroupInstanceTerms.underlyingTerms) {
    return apiGroupInstanceTerms.underlyingTerms.filter(function (_ref8) {
      var termsText = _ref8.termsText;
      return termsText;
    });
  }
  return [];
});
var hasUnderlyingTerms = exports.hasUnderlyingTerms = (0, _reselect.createSelector)(apiGroupUnderlyingTerms, function ($apiGroupUnderlyingTerms) {
  return $apiGroupUnderlyingTerms.some(function (instance) {
    return instance.underlyingTerms && instance.underlyingTerms.some(function (_ref9) {
      var termsText = _ref9.termsText;
      return termsText;
    });
  });
});
var isLoadingUnderlyingTerms = exports.isLoadingUnderlyingTerms = function isLoadingUnderlyingTerms(state) {
  return state.apiGroups.ui.isLoadingUnderlyingTerms;
};
var isUpdatingVisibility = exports.isUpdatingVisibility = function isUpdatingVisibility(state) {
  return state.apiGroups.ui.isUpdatingVisibility;
};
//# sourceMappingURL=selectors.js.map